import { ElementNode, $createParagraphNode } from 'lexical';

export class CollapsibleTitleNode extends ElementNode {
  static getType() {
    return 'collapsible-title';
  }

  static clone(node) {
    return new CollapsibleTitleNode(node.__key);
  }

  createDOM() {
    const dom = document.createElement('summary');
    dom.classList.add('Collapsible__title');
    return dom;
  }

  updateDOM() {
    return false;
  }

  static importDOM() {
    return {
      summary: () => ({
        conversion: () => ({ node: $createCollapsibleTitleNode() }),
        priority: 1,
      }),
    };
  }

  static importJSON() {
    return $createCollapsibleTitleNode();
  }

  exportDOM() {
    const element = document.createElement('summary');
    element.classList.add('Collapsible__title');
    return { element };
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      type: 'collapsible-title',
      version: 1,
    };
  }

  collapseAtStart() {
    this.getParentOrThrow().insertBefore(this);
    return true;
  }

  insertNewAfter(_, restoreSelection) {
    const containerNode = this.getParentOrThrow();

    if (!containerNode.getOpen()) {
      containerNode.toggleOpen();
    }

    const contentNode = this.getNextSibling();
    if (contentNode) {
      const firstChild = contentNode.getFirstChild();
      if (firstChild) {
        firstChild.selectStart();
      } else {
        const paragraph = $createParagraphNode();
        contentNode.append(paragraph);
        paragraph.select();
      }
    }
  }
}

export function $createCollapsibleTitleNode() {
  return new CollapsibleTitleNode();
}

export function $isCollapsibleTitleNode(node) {
  return node instanceof CollapsibleTitleNode;
}
